export default {
    request_device_log_title: "Solicitar el Registro de Dispositivos",
    request_device_log_request_log_command_has_been_sent: "Se ha enviado el comando de registro de solicitudes",
    request_device_log_error_sending_the_command: "Error al enviar el comando",
    request_device_log_label: "Utilice esta función para escalar VidFleet con problemas relacionados con el dispositivo seleccionado. Por favor, introduzca una descripción detallada sobre el problema a continuación",
    request_device_log_request_log: "Registro de solicitudes",
    request_device_log_min_characters: "La descripción debe contener al menos 5 caracteres",
}